import React, { Component } from 'react';

import {
  StyledDocumentsWrapper,
  StyledTitleDepartment,
  StyledTabsHorizontal
} from './style';
import { getDepartmentData } from '../../../../utils/apiDepartment';
import { getToken } from '../../../../utils/apiUser';
import Loading from '../../../core/Loading';
import { TabHorizontal } from '../../../core/TabsHorizontal';

import InternalDocs from './internal-docs';
import OneDriveDocs from './onedrive-docs';

const SECTIONS = {
  INTERNAL: 'INTERNAL',
  ONDDRIVE: 'ONEDRIVE'
};

export default class DocumentsPage extends Component {
  state = {
    department: null,
    currentSection: SECTIONS.INTERNAL,
    hasAccess: false
  };

  componentDidMount() {
    const {
      match: {
        params: { id }
      }
    } = this.props;

    // TODO: Manage errors
    getDepartmentData(id).then(department => {
      this.setState(() => ({ department }));
    });
    getToken().then(data => this.setState({ hasAccess: data.access_token }));
  }

  changeSection = section => {
    this.setState({ currentSection: section });
  };

  render() {
    const { department, currentSection, hasAccess } = this.state;

    if (!department) {
      return (
        <StyledDocumentsWrapper>
          <Loading size="xl" />
        </StyledDocumentsWrapper>
      );
    }

    return (
      <StyledDocumentsWrapper>
        <React.Fragment>
          <StyledTitleDepartment>{department.name}</StyledTitleDepartment>
          <StyledTabsHorizontal>
            <TabHorizontal
              id="doc-interna"
              active={currentSection === SECTIONS.INTERNAL}
              clicked={() => this.changeSection(SECTIONS.INTERNAL)}
            >
              Documentación interna
            </TabHorizontal>
            <TabHorizontal
              id="doc-ondrive"
              active={currentSection === SECTIONS.ONDDRIVE}
              clicked={() => this.changeSection(SECTIONS.ONDDRIVE)}
            >
              Documentación onedrive
            </TabHorizontal>
          </StyledTabsHorizontal>
          {currentSection && currentSection === SECTIONS.INTERNAL ? (
            <InternalDocs
              rootFolderId={department.folderId}
              associationId={department.id}
              bcreadcrumbTitle="Documentación interna"
            />
          ) : (
            <React.Fragment>
              {hasAccess.length > 0 ? (
                <OneDriveDocs teamId={department.teamId} />
              ) : (
                'No tienes permisos'
              )}
            </React.Fragment>
          )}
        </React.Fragment>
      </StyledDocumentsWrapper>
    );
  }
}
